import React from "react";
import { NavLink } from "react-router-dom";

export default function Footer() {
  const whatsappNumber = "94777797546";
  const mailTo =
    "mailto:peraengineering.pvt@gmail.com" +
    "?subject=Project%20Inquiry%20-%20Website" +
    "&body=Hi%20Pera%20Engineering%2C%0A%0AI%27m%20interested%20in%20your%20construction%20services.%20Please%20contact%20me%20back.%0A%0AThanks.";

  return (
    <footer className="relative text-neutral-300">
      {/* overlay */}
      <div className="absolute inset-0 bg-[#15212A]/95" aria-hidden="true" />

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid gap-10 md:gap-12 md:grid-cols-4">
          {/* Brand / About */}
          <div className="space-y-4">
            {/* Name image aligned to the logo height */}
            <div className="h-24 flex items-center">
              <img
                src="/images/Footer.jpeg"
                alt="PERA Engineering"
                className="max-h-12 md:max-h-16 object-contain shrink-0 bg-white rounded-md"
              />
            </div>

            <p className="text-sm leading-6 max-w-xs">
              Planning, Evaluation, Research, and Analysis. The core values
              that drive our construction solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-1 text-sm font-semibold">
              <li>
                <NavLink to="/" className="hover:text-white">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" className="hover:text-white">
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink to="/projects" className="hover:text-white">
                  Our Projects
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className="hover:text-white">
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h4 className="text-white text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-1 text-sm font-semibold">
              <li>Design-Build</li>
              <li>Remodel & Renovations</li>
              <li>Construction Consult</li>
            </ul>
          </div>

          {/* Social / Contact */}
          <div>
            <h4 className="text-white text-lg font-bold mb-4">Stay Connected</h4>
            <ul className="space-y-1 text-sm font-semibold">
              {/* Facebook */}
              <li>
                <a
                  href="https://web.facebook.com/peraeng?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit our Facebook page"
                  className="flex items-center gap-3 group hover:text-white"
                >
                  <span className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center group-hover:border-white/40">
                    <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true">
                      <path d="M22 12a10 10 0 1 0-11.5 9.9v-7H7.9V12h2.6V9.7c0-2.6 1.6-4 3.9-4 1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.5 2.9h-2.3v7A10 10 0 0 0 22 12Z" />
                    </svg>
                  </span>
                  facebook.com/@peraeng
                </a>
              </li>

              {/* Email */}
              <li>
                <a
                  href={mailTo}
                  aria-label="Send us an email"
                  className="flex items-center gap-3 group hover:text-white"
                >
                  <span className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center group-hover:border-white/40">
                    <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true">
                      <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2v.01L12 13l8-6.99V6H4zm0 12h16V8l-8 6-8-6v10z" />
                    </svg>
                  </span>
                  peraengineering.pvt@gmail.com
                </a>
              </li>

              {/* WhatsApp */}
              <li>
                <a
                  href={`https://wa.me/${whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Chat with us on WhatsApp"
                  className="flex items-center gap-3 group hover:text-white"
                >
                  <span className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center group-hover:border-white/40">
                    <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true">
                      <path d="M12 .5C5.648.5.5 5.648.5 12c0 2.13.56 4.16 1.63 5.96L.5 23.5l5.7-1.57A11.36 11.36 0 0 0 12 23.5c6.352 0 11.5-5.148 11.5-11.5S18.352.5 12 .5zm0 20.5c-1.86 0-3.67-.5-5.24-1.45l-.38-.23-3.38.93.92-3.3-.25-.39A9.28 9.28 0 0 1 2.5 12c0-5.25 4.25-9.5 9.5-9.5s9.5 4.25 9.5 9.5-4.25 9.5-9.5 9.5zm5.34-7.43c-.29-.15-1.71-.84-1.97-.93-.26-.1-.45-.15-.65.15-.19.29-.75.93-.91 1.12-.17.19-.34.22-.63.07-.29-.15-1.22-.45-2.33-1.43-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.14-.14.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.56-.9-2.13-.24-.58-.48-.5-.65-.51h-.56c-.19 0-.5.07-.76.36-.26.29-1 1-1 2.43s1.02 2.82 1.16 3.01c.14.19 2 3.05 4.85 4.27.68.29 1.21.46 1.62.59.68.21 1.3.18 1.79.11.55-.08 1.71-.7 1.95-1.37.24-.67.24-1.25.17-1.37-.07-.12-.26-.19-.55-.34z" />
                    </svg>
                  </span>
                  +94-77 779 7546
                </a>
              </li>

              {/* Address */}
              <li>
                <div className="flex items-start gap-3 group">
                  <span className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center group-hover:border-white/40">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-9 h-5 fill-current"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
                    </svg>
                  </span>
                  <div>
                    <p>No.14/3A, Suvisddarama Road, Colombo-06.</p>
                    <p>No.249/1/1, Kasthuriyar Road, Jaffna.</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 text-center text-sm md:text-base text-white">
          ©️ {new Date().getFullYear()} Pera Engineering Construction (Pvt) Ltd. All Rights Reserved.
          <br />
          <span className="text-gray-300 font-medium">
            Developed by{" "}
            <a
              href="https://codebytz.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-emerald-500 hover:text-emerald-400 transition-colors"
            >
              CODEBYTZ TECHNOLOGIES
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}